// contract
export const ROAMING_CONTRACT_SYNC_REQUESTED = 'ROAMING_CONTRACT_SYNC_REQUESTED';
export const ROAMING_CONTRACT_SYNC_SUCCESS = 'ROAMING_CONTRACT_SYNC_SUCCESS';
export const ROAMING_CONTRACT_SYNC_FAILED = 'ROAMING_CONTRACT_SYNC_FAILED';

export const ROAMING_CONTRACT_DRAFT_DELETE_REQUESTED = 'ROAMING_CONTRACT_DRAFT_DELETE_REQUESTED';
export const ROAMING_CONTRACT_DRAFT_DELETE_SUCCESS = 'ROAMING_CONTRACT_DRAFT_DELETE_SUCCESS';
export const ROAMING_CONTRACT_DRAFT_DELETE_FAIL = 'ROAMING_CONTRACT_DRAFT_DELETE_FAIL';